var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VuePerfectScrollbar',{staticClass:"e-content__inner"},[_c('div',{staticClass:"e-content__scroll"},[_c('the-chat')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }